import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SubscriberDependentsContentStyled = styled.div`
  padding: 3rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const NoDependentsMessageStyled = styled.p`
  ${typography.bold[18]};
  margin: 0 auto;
  color: ${colors.neutral[900]};
`;
